import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import LoadingSpinner from '../../../components/LoadingSpinner'
import { dialogEmptyStateTextSx } from '../../../constants/dialogSx'
import {
  RBAC_ADD_USERS_EMPTY_STATE_MESSAGE,
  RBAC_ADD_USERS_LOADING_TEXT,
  RBAC_ADD_USERS_MIN_VISIBLE_ROWS,
  RBAC_ADD_USERS_ROW_MIN_HEIGHT,
  rbacAddUsersListSx
} from '../constants/rbacAddUsersToRoleDialogConstants'
import RbacAddUsersListItem from './RbacAddUsersListItem'

export default function RbacAddUsersList({
  users,
  loadingUsers,
  loadingMore,
  selectedIds,
  onToggleUser,
  onScroll
}) {
  return (
    <Box data-testid="rbac-add-users-list" sx={rbacAddUsersListSx} onScroll={onScroll}>
      {loadingUsers ? (
        <Box
          sx={{
            minHeight: RBAC_ADD_USERS_MIN_VISIBLE_ROWS * RBAC_ADD_USERS_ROW_MIN_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <LoadingSpinner text={RBAC_ADD_USERS_LOADING_TEXT} />
        </Box>
      ) : users.length === 0 ? (
        <Box
          sx={{
            minHeight: RBAC_ADD_USERS_MIN_VISIBLE_ROWS * RBAC_ADD_USERS_ROW_MIN_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: 2
          }}
        >
          <Typography sx={dialogEmptyStateTextSx}>
            {RBAC_ADD_USERS_EMPTY_STATE_MESSAGE}
          </Typography>
        </Box>
      ) : (
        <>
          {users.map((user) => (
            <RbacAddUsersListItem
              key={user.id}
              user={user}
              selected={selectedIds.has(String(user.id))}
              onToggle={onToggleUser}
            />
          ))}
          {loadingMore ? (
            <Box
              sx={{
                py: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <LoadingSpinner text={RBAC_ADD_USERS_LOADING_TEXT} />
            </Box>
          ) : null}
        </>
      )}
    </Box>
  )
}
